import {Component, Input, OnInit} from '@angular/core';
import {AutorizacaoService} from "../../services/autorizacao.service";
import {CaixaService} from "../services/caixa.service";
import {ConstantsService} from "../../fidelidade/ConstantsService";
import {ImpressaoService} from "../../services/impressao.service";

@Component({
  selector: 'app-gestao-de-caixa',
  templateUrl: './gestao-de-caixa.component.html',
  styleUrls: ['./gestao-de-caixa.component.scss']
})
export class GestaoDeCaixaComponent implements OnInit {
  abrirDialog = false;
  usuarioLogado: any;
  hora: Date;
  saldoInicial: number;
  totalEntradasDinheiro = 100;
  totalEntradas = 100;
  totalSaidasDinheiro = 50
  ;
  saldoFinalDinheiro = 50;
  saldoFinal = 50;
  caixa: any;
  resumo: any;
  mensagemErro: string;
   carregando: boolean;
  fecharDialog: any;
  saldoConferido: number;
  mensagemErroFechamento: any;
  sangriaDialog: any;
  valorSangria: any;
  justificativaSangria: any;
  mensagemErroSangria: any;
  mensagemAdvertenciaFechamento: any;
  empresa: any;
  configImpressao: any;

  @Input() online: boolean
  abrindoCaixa: any;
   adicionarSaldoDialog: any;
  valorAdicaoSaldo: any;
  mensagemErroAdicaoSaldo: any;


  constructor(private autorizacaoService: AutorizacaoService, private constantsService: ConstantsService,
              private impressaoService: ImpressaoService, private caixaService: CaixaService) {
    this.usuarioLogado = this.autorizacaoService.getUser();
    this.carregando = true;

    this.constantsService.empresa$.subscribe( (empresa: any) => {
      if(empresa) {
        this.empresa = empresa
        this.configImpressao = this.empresa.configImpressao;
      }
    })
  }

  ngOnInit(): void {
    this.caixaService.obtenhaCaixaAtual(this.online).then((resposta: any) => {
      this.carregando = false;
      this.caixa = resposta.caixa;
      this.resumo = this.normalizarResumoCaixa(resposta.resumo);
    });
  }

  abrirCaixa() {
    this.hora = new Date();
    this.abrirDialog = true;

  }

  cancelar() {
    this.abrirDialog = false;
  }

  confirmar() {
    this.abrindoCaixa = true
    this.caixaService.abraCaixa(this.saldoInicial).then((resposta: any) => {
      this.abrindoCaixa = false
      this.abrirDialog = false;
      this.caixa = resposta.caixa;
      this.resumo = this.normalizarResumoCaixa(resposta.resumo)
      console.log(this.caixa)
    }).catch((erro: any) => {
      this.abrindoCaixa = false
      console.log(erro)
      this.mensagemErro = erro
    })
  }



  fecharCaixa() {

    this.hora = new Date()
    this.caixaService.podeFecharCaixa().then((resposta: any) => {
      if(resposta.temErro) {
        this.mensagemErroFechamento = resposta.mensagem
      }

      if(resposta.temAdvertencia) {
        this.mensagemAdvertenciaFechamento = resposta.mensagem
      }
      this.fecharDialog = true;
    })

  }

  imprimirResumo() {
    if(!this.resumo) return;

    if(this.configImpressao?.imprimirTXT)
      return this.imprimaNativamente(this.obtenhaImpressoraPadrao());

    this.abraRelatorioGrafico(this.resumo);
  }

  private async imprimaNativamente(impressora: any) {
    if(!impressora)
      impressora = this.obtenhaImpressoraPadrao();

    if(!impressora)
      return this.impressaoService.onErrosImpressao.emit('Nenhuma impressora configurada');

    await this.impressaoService.imprimaResumoCaixa(this.resumo, impressora);
  }

  private abraRelatorioGrafico(resumoCaixa: any) {
    if(!resumoCaixa?.id)
      return this.impressaoService.onErrosImpressao.emit('Nao foi possivel identificar o caixa para impressao');

    const impressora = this.obtenhaImpressoraPadrao();
    const url = this.impressaoService.getRelatorioCaixaUrl({
      idCaixa: resumoCaixa?.id,
      idImpressora: impressora?.id || impressora?._id,
      a4: impressora?.tamanhoPapel === 'LayoutA4',
      autoPrint: true
    });

    window.open(url);
  }

  private obtenhaImpressoraPadrao() {
    return this.configImpressao?.impressoras?.[0];
  }

  private normalizarResumoCaixa(resumo: any) {
    if(!resumo) return resumo;

    resumo.horaAbertura = resumo.horaAbertura ? new Date(resumo.horaAbertura) : null;
    resumo.horaFechamento = resumo.horaFechamento ? new Date(resumo.horaFechamento) : null;
    resumo.horaEmissao = resumo.horaEmissao ? new Date(resumo.horaEmissao) : null;

    return resumo;
  }


  cancelarFechamento() {

  }

  confirmarFechamento() {
    //fecha o caixa no servidor
    this.caixaService.fecheCaixa(this.caixa, this.saldoConferido).then((resposta: any) => {
      this.fecharDialog = false;
      this.caixa = null
      this.resumo = null
    }).catch(
      (erro: any) => {
        this.mensagemErroFechamento = erro
      }
    )
  }

  confirmarEImprimirRelatorio() {
    this.caixaService.fecheCaixa(this.caixa, this.saldoConferido).then((resumo: any) => {
      if(resumo.status === 'FECHADO') {
        this.resumo = this.normalizarResumoCaixa(resumo)

        if(this.configImpressao?.imprimirTXT)
          this.imprimaNativamente(this.obtenhaImpressoraPadrao())
        else
          this.abraRelatorioGrafico(this.resumo)

        this.fecharDialog = false;
        this.caixa = null
        this.resumo = null

      }
    }).catch(
      (erro: any) => {
        this.mensagemErroFechamento = erro
      }
    )
  }

  adicionarSaldo() {
    this.adicionarSaldoDialog = true;
  }


  realizarSangria() {
    this.sangriaDialog = true;
  }

  cancelarSangria() {
    this.sangriaDialog = false;
  }

  confirmarSangria() {
    this.caixaService.sangreCaixa(this.valorSangria, this.justificativaSangria).then((resposta: any) => {
      this.sangriaDialog = false;
      this.caixa = resposta.caixa;
      this.resumo = this.normalizarResumoCaixa(resposta.resumo);
    }).catch((erro: any) => {
      this.mensagemErroSangria = erro
    })
  }

  confirmarEImprimirSangria() {

  }

  cancelarAdicaoSaldo() {
    this.adicionarSaldoDialog = false;

  }

  confirmarAdicaoSaldo() {
    this.caixaService.adicioneDinheiro(this.valorAdicaoSaldo).then((resposta: any) => {
      this.adicionarSaldoDialog = false;
      this.caixa = resposta.caixa;
      this.resumo = this.normalizarResumoCaixa(resposta.resumo);
    }).catch((erro: any) => {
      this.mensagemErroAdicaoSaldo = erro
    })
  }
}
